/**
 * A Generic Controller which supports extend and Backbone Events
 */
'use strict';

var Backbone = require('backbone');
var _ = require('underscore');
var mediator = require('./mediator');
var config = require('./config');

function GenericController(options) {
  options = options || {};
  _.extend(this, _.pick(options, ['collection']));
  this.dataChanged = _.debounce(this.dataChanged, 20);
  this.model = options.model || new Backbone.Model();
  this.listenTo(this.model, 'change', this.dataChanged);
  this.mediator = options.mediator || mediator;
  this.initialize.apply(this, arguments);
}

GenericController.prototype.initialize = _.noop();

GenericController.prototype.dataChanged = function() {
  this.trigger('change');
};

GenericController.prototype.checkResponseStatus = function(statusCode) {
  if (statusCode === 401) {
    this.mediator.trigger(config.events.session.unauthorizedResponseReceived);
  }
};

GenericController.prototype.includeInList = function(modelProperty, value, include) {
  include = include === false ? false : true;
  var fetchingList = _.clone(this.model.get(modelProperty)),
    includedAlready = _.contains(fetchingList, value),
    changed = false;
  if (include && !includedAlready) {
    fetchingList.push(value);
    changed = true;
  } else if (!include && includedAlready) {
    fetchingList.splice(fetchingList.indexOf(value), 1);
    changed = true;
  }
  if (changed) {
    this.model.set(modelProperty, fetchingList);
  }
};

GenericController.extend = Backbone.Model.extend;
_.extend(GenericController.prototype, Backbone.Events);

module.exports = GenericController;



// WEBPACK FOOTER //
// ./assets/js/GenericController.js